// extracted by mini-css-extract-plugin
export default {"link":"StyledLink_link__DoWVa"};